module.exports = __webpack_public_path__ + "assets/img/reserve-button-7c9f432d.png";